<template>
  <v-app @toggleDrawer="$refs.navDrawer.toggleDrawer()">
    <navdrawer
      v-if="user"
      ref="navDrawer"
      :key="company"
    />
    <navbar />
    <v-content>
      <v-container
        grid-list-lg
        fluid
      >
        <router-view
          :key="$route.fullPath"
          @hide-drawer="hideDrawer"
        />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Navbar from '~/components/Navbar'
import Navdrawer from '~/components/Navdrawer'
import { mapGetters } from 'vuex'

export default {
  name: 'MainLayout',

  components: {
    Navbar,
    Navdrawer
  },
  computed: mapGetters({
    user: 'auth/user',
    company: 'auth/company'
  }),

  methods: {
    hideDrawer () {
      this.$refs.navDrawer.drawer = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/layouts/default.vue